// extracted by mini-css-extract-plugin
export default {"table":"fit-table_table__Ekmmt","th":"fit-table_th__X8SuJ","td":"fit-table_td__nsYSA","tr":"fit-table_tr__S4w+h","empty":"fit-table_empty__13Xzh"};